import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { logout, getCurrentUser } from "../services/auth";
import {
  List,
  BoxArrowRight,
  PersonCircle,
  ChevronDown,
  ShieldLock,
} from "react-bootstrap-icons";
import "../App.css"

const Header = ({ toggleSidebar, sidebarCollapsed, toggleMobileSidebar }) => {
  const navigate = useNavigate();
  const userEmail = getCurrentUser();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const getInitials = (email) => {
    if (!email) return "A";
    return email.charAt(0).toUpperCase();
  };

  const getDisplayName = (email) => {
    if (!email) return "Admin";
    return email.split("@")[0];
  };

  const handleLogout = () => {
    localStorage.clear();
    logout();
    navigate("/login");
  };

  // Close dropdown on outside click
  useEffect(() => {
    const handleClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  return (
    <>

      <header className="admin-header">
        {/* Desktop sidebar toggle */}
        <button
          onClick={toggleSidebar}
          className="toggle-btn desktop-toggle"
          aria-label="Toggle sidebar"
        >
          <List size={18} />
        </button>

        {/* Mobile sidebar toggle */}
        <button
          onClick={toggleMobileSidebar}
          className="toggle-btn mobile-toggle"
          aria-label="Open menu"
        >
          <List size={18} />
        </button>

        <div className="header-divider" />

        <span className="header-title">Admin Panel</span>

        <div className="header-spacer" />

        {/* User profile */}
        <div className="user-profile" ref={dropdownRef}>
          <button
            className={`profile-trigger ${showDropdown ? "open" : ""}`}
            onClick={() => setShowDropdown((v) => !v)}
            aria-label="User menu"
          >
            <div className="avatar">{getInitials(userEmail)}</div>
            <div className="profile-info">
              <span className="profile-name">{getDisplayName(userEmail)}</span>
              <span className="profile-role">Administrator</span>
            </div>
            <ChevronDown
              size={13}
              className={`chevron-icon ${showDropdown ? "rotated" : ""}`}
            />
          </button>

          {showDropdown && (
            <div className="profile-dropdown">
              {/* Dropdown header */}
              <div className="dropdown-header px-3 py-2 d-flex align-items-center gap-2">
                <div className="dropdown-avatar">{getInitials(userEmail)}</div>
                <div style={{ overflow: "hidden" }}>
                  <div className="dropdown-name">
                    {getDisplayName(userEmail)}
                  </div>
                  <div className="dropdown-email">{userEmail}</div>
                </div>
              </div>

              <div className="dropdown-divider" />

              <button
                className="dropdown-item danger px-3 py-2"
                onClick={() => {
                  setShowDropdown(false);
                  setShowLogoutConfirm(true);
                }}
              >
                <BoxArrowRight size={15} className="pe-2"/>
                Sign Out
              </button>
            </div>
          )}
        </div>
      </header>

      {/* Logout confirm modal */}
      {showLogoutConfirm && (
        <div className="modal-backdrop">
          <div className="modal-box">
            <div className="modal-icon">🚪</div>
            <p className="modal-title">Sign out?</p>
            <p className="modal-body">
              You'll be returned to the login screen. Any unsaved changes will
              be lost.
            </p>
            <div className="modal-buttons">
              <button
                onClick={() => setShowLogoutConfirm(false)}
                className="cancel-button"
              >
                Cancel
              </button>
              <button onClick={handleLogout} className="confirm-button">
                Sign Out
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
